export default __webpack_public_path__ + "static/media/img5.dbe05315.png";